<template>
    <div class="sx-video img-full" :class="vdoId?'':'pause'" @click="doPlay">
        <video
            v-if="vdoId"
            id="vdoPlay"
            controls="controls"
            autoplay="autoplay"
            width="100%"
            poster="static/img/female/vdo_0.jpg"
        >
            <source
                :src="'http://cloud.video.taobao.com/play/u/14547989/p/2/e/6/t/1/'+vdoId+'.mp4'"
                type="video/mp4"
            />
        </video>
        <img :src="vdoImg[sex][sxi]" v-else />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "video-player",
    data() {
        return {
            vdoId: "",
            video:[
                ["238171491406","237943337451","238171767397","237853644023","238069278916","238172207325","238172207475","238172391240","237853844142","237944345017","238172435686","238172695353"],
                ["238174531134","238174559233","238071554108","238071410708","237946089912","238174899480","238175031246","237946433877","238072022162","237856324428","238072150164","237946945945"]
            ]
        };
    },
    props: {
        sxi: [Number, String],
        sex: [Number, String],
        sexdata: [Object]
    },
    computed: {
        ...mapGetters(["vdoImg"])
    },
    watch: {
        datas(res) {
            console.log("watch datas", res);
        }
    },
    mounted() {
        //this.getIndex();
    },
    methods: {
        ...mapActions(["getIndex"]),
        doPlay() {
            console.log(this.video);
            this.vdoId = this.video[this.sex][this.sxi];
            //this.vdoId = this.sxdata.
            //'http://cloud.video.taobao.com/play/u/14547989/p/2/e/6/t/1/238171491406.mp4'
        }
    }
};
</script>

<style scoped>
.sx-video {
    position: relative;
    padding: 5px;
}
.sx-video.pause:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 60px;
    height: 60px;
    margin: -30px;
    background: url(../assets/img/play.png) no-repeat center center;
    background-color: rgba(0, 0, 0, 0.4);
    background-size: cover;
    border-radius: 100%;
    box-shadow: 0 0 5px #000;
}
.sx-video img {
    width: 100%;
    border-radius: 5px;
}
#vdoPlay {
    border-radius: 5px;
}
</style>